import React from 'react';
import { Handle } from './components/Handle';
import { ItemIcon } from './components/ItemIcon';
import {
  useItemHandleFragment,
  useItemHandleFragmentProps,
} from './hooks/useItemHandleFragment';
import { useItemLabel } from './hooks/useItemLabel';
import { useItemLinkProps } from './hooks/useItemLinkProps';
import { useItemName } from './hooks/useItemName';
import { useItemTypeDescription } from './hooks/useItemTypeDescription';
import { useItemRightIcon } from './hooks/useItemRightIcon';
import { useItemPins } from './hooks/useItemPins';

export interface ItemHandleProps extends useItemHandleFragmentProps {
  linkBox?: boolean;
}

export const ItemHandle = ({ item: itemRef, linkBox }: ItemHandleProps) => {
  const item = useItemHandleFragment({ item: itemRef });

  return (
    <Handle
      name={useItemName(item)}
      label={useItemLabel(item)}
      pins={useItemPins(item)}
      description={useItemTypeDescription(item)}
      icon={<ItemIcon item={item} />}
      rightIcon={useItemRightIcon(item)}
      linkProps={useItemLinkProps(item)}
      linkBox={linkBox}
    />
  );
};
